import PropTypes from "prop-types";
import React, { Fragment,useState } from "react";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import LocationMap from "../../components/contact/LocationMap";
import { getCompany } from "../../Services/API/Get";
import { postContacts } from "../../Services/API/Post";
import { useToasts } from "react-toast-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/loadingSpinner";

const Contact = ({ location }) => {
  const { pathname } = location;
  const { addToast } = useToasts();
  const [lopen, setlopen] = useState(false);

  const [company, setcompany] = useState("");

  const [firstName, setfirstName] = useState("");
  const [subject, setsubject] = useState("");
  const [email, setemail] = useState("");
  const [message, setmessage] = useState("");

  const [errfirstName, seterrfirstName] = useState(false);
  const [errsubject, seterrsubject] = useState(false);
  const [errmessage, seterrmessage] = useState(false);
  const [erremail, seterremail] = useState(false);

  const CompanyGet = () => {
    getCompany()
    .then((res) => {
      console.log(res.data);
      console.log("company res>>>",res.data[res.data.length - 1])
      setcompany(res.data[res.data.length - 1]);
      // setLogo(res.data[res.data.length - 1].image)
      // this.setState({
      //   logo: res.data[res.data.length - 1].image,
      // });
    })
    .catch((error) => {
      console.error(error);
    });
  };

  const contactUs = (event) => {

    event.preventDefault();

    const obj = {
      name:firstName,
      email: email,
      subject: subject,
      message: message,
    };

    console.log("obj", obj);

    if (firstName === "") {
      seterrfirstName(true);
    }
    if (subject === "") {
      seterrsubject(true);
    }
    if (email === "") {
      seterremail(true);
    }

    if (message === "") {
      seterrmessage(true);
    }


    if(
      firstName !== "" &&
      email !== "" &&
      subject !== "" &&
      message !== ""
   
      ){
        setlopen(true);
        postContacts(obj)
        .then((res) => {
          setlopen(false);
          console.log("res>>>",res);
          addToast(`Your enquiry has been successfully submitted`, { appearance: "success", autoDismiss: true });
        })
        .catch((error) => {
          console.error(error);
          setlopen(false);
          addToast(error.response.data.message, { appearance: "warning", autoDismiss: true });
        });

      }


   
  };

  React.useEffect(() => {
    CompanyGet();
   
  }, []);

  return (
    <Fragment>
            <LoadingSpinner open={lopen} />
      <MetaTags>
        <title>OZ Rentals | Contact</title>
        <meta
          name="description"
          content="Contact of flone react minimalist eCommerce template."
        />
      </MetaTags>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
        Contact
      </BreadcrumbsItem>
      <LayoutOne headerTop="visible">
        {/* breadcrumb */}
        <Breadcrumb />
        <div className="contact-area pt-100 pb-100">
          <div className="container">
            <div className="contact-map mb-10">
           
              <LocationMap latitude=" -37.98054440577276" longitude="145.191588" />
            </div>
            <div className="custom-row-2">
              <div className="col-lg-5 col-md-5">
                <div className="contact-info-wrap">
                  <div className="single-contact-info">
                    <div className="contact-icon">
                      <i className="fa fa-phone" />
                    </div>
                    <div className="contact-info-dec">
                      {/* <p>+012 345 678 102</p> */}
                      <p>
                        <a href={`tel:${company?.phoneNumber}`}>
                        {company?.phoneNumber}
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="single-contact-info">
                    <div className="contact-icon">
                      <i className="fa fa-globe" />
                    </div>
                    <div className="contact-info-dec">
                      <p>
                        <a href={`mailto:${company?.email}`}>
                        {company?.email}
                        </a>
                      </p>
                      {/* <p>
                        <a href={company?.url}
                         target="_blank"
                         rel="noopener noreferrer"
                        >
                        {"Website"}
                        </a>
                      </p> */}
                    </div>
                  </div>
                  <div className="single-contact-info">
                    <div className="contact-icon">
                      <i className="fa fa-map-marker" />
                    </div>
                    <div className="contact-info-dec">
                      <p>{company?.address}, </p>
                      <p>{company?.suburb} , {company?.postCode}</p>
                    </div>
                  </div>
                  <div className="contact-social text-center">
                    <h3>Follow Us</h3>
                    <ul>
                      <li>
                        <a href={company?.facebook}
                         target="_blank"
                         rel="noopener noreferrer"
                        >
                          <i className="fa fa-facebook" />
                        </a>
                      </li>
                      <li>
                        <a href={company?.instagram}
                         target="_blank"
                         rel="noopener noreferrer"
                        >
                          <i className="fa fa-instagram" />
                        </a>
                      </li>
                      {/* <li>
                        <a href="//thumblr.com">
                          <i className="fa fa-tumblr" />
                        </a>
                      </li>
                      <li>
                        <a href="//vimeo.com">
                          <i className="fa fa-vimeo" />
                        </a>
                      </li>
                      <li>
                        <a href="//twitter.com">
                          <i className="fa fa-twitter" />
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-7">
                <div className="contact-form">
                  <div className="contact-title mb-30">
                    <h2>Get In Touch</h2>
                  </div>
                  <form className="contact-form-style" onSubmit={contactUs}>
                    <div className="row">
                      <div className="col-lg-6">
                        <input name="name" placeholder="Name*" type="text" 
                          onChange={(e) => {
                            setfirstName(e.target.value);
                            seterrfirstName(false);
                          }}
                        />
                               {errfirstName && (
                                <div
                                  style={{
                                    textAlign: "right",
                                    // fontFamily: FONTS_INTER,
                                    // margin: "5px 0px",
                                    fontSize: "9pt",
                                    color: "red",
                                    marginTop:"-30px",
                                    marginBottom:"10px",
                                  }}
                                >
                                  This Field is Requied
                                </div>
                              )}
                      </div>
                      <div className="col-lg-6">
                        <input name="email" placeholder="Email*" type="email" 
                           onChange={(e) => {
                            setemail(e.target.value);
                            seterremail(false);
                          }}
                          
                        />
                              {erremail && (
                                <div
                                  style={{
                                    textAlign: "right",
                                    // fontFamily: FONTS_INTER,
                                    // margin: "5px 0px",
                                    fontSize: "9pt",
                                    color: "red",
                                    marginTop:"-30px",
                                    marginBottom:"10px",
                                  }}
                                >
                                  This Field is Requied
                                </div>
                              )}
                      </div>
                      <div className="col-lg-12">
                        <input
                          name="subject"
                          placeholder="Subject*"
                          type="text"
                          onChange={(e) => {
                            setsubject(e.target.value);
                            seterrsubject(false);
                          }}
                        />
                              {errsubject && (
                                <div
                                  style={{
                                    textAlign: "right",
                                    // fontFamily: FONTS_INTER,
                                    // margin: "5px 0px",
                                    fontSize: "9pt",
                                    color: "red",
                                    marginTop:"-30px",
                                    marginBottom:"10px",
                                  }}
                                >
                                  This Field is Requied
                                </div>
                              )}
                      </div>
                      <div className="col-lg-12">
                        <textarea
                          name="message"
                          placeholder="Your Message*"
                          defaultValue={""}
                          onChange={(e) => {
                            setmessage(e.target.value);
                            seterrmessage(false);
                          }}
                        />
                              {errmessage && (
                                <div
                                  style={{
                                    textAlign: "right",
                                    // fontFamily: FONTS_INTER,
                                    // margin: "5px 0px",
                                    fontSize: "9pt",
                                    color: "red",
                                    marginTop:"-10px",
                                    marginBottom:"10px",
                                  }}
                                >
                                  This Field is Requied
                                </div>
                              )}
                        <button className="submit" type="submit"
                        >
                          SEND
                        </button>
                      </div>
                    </div>
                  </form>
             
                  {/* <p className="form-message" /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

Contact.propTypes = {
  location: PropTypes.object
};

export default Contact;
